import { GenericAction, GenericActionWithPayload } from "./action-types";
import { Product } from "./product";
import {
  DeleteIndividualOptionsAction,
  DeleteOptionLineAction,
  EditIndividualOptionsAction,
  SelectedLineOptions,
} from "./option";
import { SelectedLineComboChoices, SelectedComboChoices } from "./combo-type";
import { DeleteBasketPayloadType, EditBasketPayloadType } from "./basket";

type LineItemType = {
  id: number;
  productId: number;
  quantity: number;
  variationId?: number;
  parentId?: number;
  children?: number[];
  _isUnavailable?: boolean;
  comboSelections?: Record<number, SelectedComboChoices[]>;
};

type LineItemWithProdType = {
  id: number | string;
  productId: string;
  title: string;
  variationId?: number;
  isVariationItem?: boolean;
  price?: number;
  quantity: number;
  total: number;
  oldTotal?: number;
  _isUnavailable?: boolean;
  inMenu?: boolean;
  countryCode: string;
  selectedLineOptions: SelectedLineOptions[];
  selectedLineComboChoices: SelectedLineComboChoices[];
  comboChoices: SelectedComboChoices[];
  choices?: SelectedComboChoices[];
  children?: number[];
};

type LineItemTotalsType = {
  priceTotal: number;
  quantityTotal: number;
};

type EditItemsProps = {
  onClose: () => void;
  onUpdatePress: () => void;
  visible?: boolean;
  lineItemId: string;
};

type EditTposItemProps = {
  customiseIndividual?: boolean;
  setShowCustomiseIndividual?: () => void;
} & EditItemsProps;

type AddToBasketPayloadType = {
  item: Product;
  variationId?: number;
  quantity: number;
  comboSelections?: Record<number, SelectedComboChoices[]>;
};

type AddToBasketAction = GenericActionWithPayload<
  "ADD_TO_BASKET",
  AddToBasketPayloadType
>;

type EditBasketAction = GenericActionWithPayload<
  "EDIT_BASKET",
  EditBasketPayloadType
>;

type DeleteBasketAction = GenericActionWithPayload<
  "DELETE_BASKET",
  DeleteBasketPayloadType
>;

type ClearBasketAction = GenericAction<"CLEAR_BASKET">;
type ClearBasketAfterOrderAction = GenericAction<"CLEAR_BASKET_AFTER_ORDER">;

type LineItemsAction =
  | AddToBasketAction
  | EditBasketAction
  | DeleteBasketAction
  | GenericAction<"SIGNOUT">
  | ClearBasketAction
  | ClearBasketAfterOrderAction
  | EditIndividualOptionsAction
  | DeleteIndividualOptionsAction
  | DeleteOptionLineAction;

export type {
  LineItemType,
  LineItemWithProdType,
  LineItemTotalsType,
  EditItemsProps,
  EditTposItemProps,
  LineItemsAction,
  AddToBasketPayloadType,
  AddToBasketAction,
  EditBasketAction,
  DeleteBasketAction,
  ClearBasketAction,
  ClearBasketAfterOrderAction,
};
